var map = {
	"./eye-off.svg": "7d35",
	"./eye-on.svg": "e3ea",
	"./icon-aala.svg": "b49e",
	"./icon-add-user.svg": "65c7",
	"./icon-alert.svg": "908b",
	"./icon-ancillary-custodial.svg": "c047",
	"./icon-ancillary-diagnostic.svg": "18a6",
	"./icon-ancillary-tests.svg": "e9e8",
	"./icon-ancillary-therapeutic.svg": "b881",
	"./icon-arrow-left-blue.svg": "0f13",
	"./icon-arrow-left.svg": "d083",
	"./icon-arrow-right-blue.svg": "da63",
	"./icon-arrow-right.svg": "e00b",
	"./icon-arrow.svg": "46c7",
	"./icon-attach.svg": "371a",
	"./icon-bell.svg": "a730",
	"./icon-bold.svg": "ff99",
	"./icon-building.svg": "873e",
	"./icon-calendar-blue.svg": "40d0",
	"./icon-calendar.svg": "9d9b",
	"./icon-call.svg": "1ba3",
	"./icon-camera-blue.svg": "1a14",
	"./icon-camera.svg": "a5cd",
	"./icon-chains.svg": "fcfc",
	"./icon-chat-bot-down.svg": "7c28",
	"./icon-chat-bot.svg": "630f",
	"./icon-chat-circle.svg": "1c0f",
	"./icon-chat-notification.svg": "1f2e",
	"./icon-chatgpt.svg": "d1c6",
	"./icon-check-blue.svg": "04f2",
	"./icon-check-circle.svg": "49f6",
	"./icon-check.svg": "20f4",
	"./icon-checkbox-off.svg": "8233",
	"./icon-checkbox-on.svg": "64cd",
	"./icon-chose.svg": "e3ed",
	"./icon-clock-circle.svg": "35f7",
	"./icon-clock-reschedule.svg": "601b",
	"./icon-clock-white.svg": "4f34",
	"./icon-close-white.svg": "15a0",
	"./icon-close.svg": "10c2",
	"./icon-cloud-dark.svg": "3673",
	"./icon-cloud.svg": "4a19",
	"./icon-colleague-transparent.svg": "8c2b",
	"./icon-colleague.svg": "e268",
	"./icon-cup.svg": "2b46",
	"./icon-current.svg": "e791",
	"./icon-delete.svg": "cfd0",
	"./icon-direct-referral.svg": "8c6c",
	"./icon-discard.svg": "abd8",
	"./icon-document.svg": "7510",
	"./icon-dot-off.svg": "916f",
	"./icon-dot-on.svg": "b8a6",
	"./icon-dots-dark.svg": "c11b",
	"./icon-dots-white.svg": "099e",
	"./icon-download.svg": "a898",
	"./icon-dropdown-arrows.svg": "e7c9",
	"./icon-dropdown-check.svg": "f7f5",
	"./icon-dropdown.svg": "aa3c",
	"./icon-edit.svg": "0ef7",
	"./icon-email.svg": "1c76",
	"./icon-emergancy.svg": "575e",
	"./icon-eprescribe-review.svg": "0ae04",
	"./icon-eprescribe.svg": "ccc5",
	"./icon-error.svg": "ef0c",
	"./icon-file.svg": "d8d7",
	"./icon-filter.svg": "6dc3",
	"./icon-forbidden.svg": "7e45",
	"./icon-gmail.svg": "1035",
	"./icon-google-transparent.svg": "5e78",
	"./icon-heart-off.svg": "d097",
	"./icon-heart-on.svg": "4fe4",
	"./icon-heart.svg": "8390",
	"./icon-info.svg": "bfb4",
	"./icon-insurance-dark.svg": "3bd1",
	"./icon-insurance.svg": "9b79",
	"./icon-insure.svg": "3813",
	"./icon-italic.svg": "7f39",
	"./icon-leftarrow.svg": "caf7",
	"./icon-link.svg": "4364",
	"./icon-location-blue.svg": "f07f",
	"./icon-location.svg": "1c40",
	"./icon-match-referral.svg": "3514",
	"./icon-medmatch-blue.svg": "ce05",
	"./icon-member-dark.svg": "e624",
	"./icon-member-gray.svg": "03ff",
	"./icon-member-transparent.svg": "ded2",
	"./icon-member-white.svg": "8d3b",
	"./icon-member.svg": "f361",
	"./icon-menu-arrow.svg": "065b",
	"./icon-menu-availability.svg": "43c8",
	"./icon-menu-home.svg": "20e1",
	"./icon-menu-network.svg": "0127",
	"./icon-menu-practice.svg": "eaa5",
	"./icon-menu-referrals.svg": "372d",
	"./icon-menu.svg": "0ef9",
	"./icon-message.svg": "e002",
	"./icon-messages.svg": "5e70",
	"./icon-microsoft-logo.svg": "f2bf",
	"./icon-minus.svg": "946c",
	"./icon-msg.svg": "3a19",
	"./icon-navigation.svg": "3fa9",
	"./icon-no-time.svg": "22fe",
	"./icon-notification.svg": "05e0",
	"./icon-notifications.svg": "b9ba",
	"./icon-olist.svg": "b79f",
	"./icon-open-link.svg": "32d6",
	"./icon-outlook.svg": "a3cd",
	"./icon-phone.svg": "d8a4",
	"./icon-plus-circle.svg": "0c02",
	"./icon-print.svg": "63a8",
	"./icon-radio-check.svg": "0736",
	"./icon-radio-off.svg": "e21f",
	"./icon-radio-on.svg": "b0b8",
	"./icon-record.svg": "708c",
	"./icon-referral-add.svg": "b1ea",
	"./icon-referral-track.svg": "3e68",
	"./icon-referrals-pool.svg": "84e8",
	"./icon-reschedule.svg": "db2b",
	"./icon-scissors.svg": "7d42",
	"./icon-search-gray.svg": "b0c6",
	"./icon-search-white.svg": "1a45",
	"./icon-search.svg": "f3ca",
	"./icon-send-message.svg": "98d74",
	"./icon-send.svg": "5b06",
	"./icon-setting.svg": "875d",
	"./icon-small-white-check.svg": "90ce",
	"./icon-small-white-warning.svg": "1e66",
	"./icon-sms.svg": "79c1",
	"./icon-star-filled.svg": "f6fc",
	"./icon-star.svg": "154c",
	"./icon-stethoscope.svg": "430c",
	"./icon-success.svg": "436f",
	"./icon-summary.svg": "3183",
	"./icon-switch-made.svg": "4333",
	"./icon-switch-received.svg": "f08b",
	"./icon-time.svg": "1c0b",
	"./icon-timeline.svg": "4750",
	"./icon-timer.svg": "0cfe",
	"./icon-trash-bin.svg": "52b3",
	"./icon-trash-white.svg": "b84e",
	"./icon-ulist.svg": "4ef6",
	"./icon-underline.svg": "0b1e",
	"./icon-upload.svg": "a11e",
	"./icon-user-profile-gray.svg": "c12b",
	"./icon-user-profile.svg": "28b7",
	"./icon-user.svg": "6054",
	"./icon-users.svg": "14c4",
	"./icon-view.svg": "cba4",
	"./icon-warning-white.svg": "d884",
	"./icon-warning.svg": "825d",
	"./icon-white-check.svg": "428e",
	"./icon-white-warning.svg": "8565",
	"./icon-x.svg": "02b1",
	"./icon-yahoo.svg": "c9c3",
	"./picture-desktop.svg": "7a57",
	"./picture-email-sent.svg": "a981",
	"./picture-error.svg": "9c33",
	"./picture-logo-white.svg": "9104",
	"./picture-logo.svg": "810a",
	"./picture-slider-left.svg": "52ed",
	"./picture-slider-right.svg": "e781",
	"./picture-success.svg": "d546"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "830a";